import { useSelector } from 'react-redux';
import { HISTORY_SCOPE } from '@src/constants/history';

const useCanRedo = (scope = HISTORY_SCOPE.DUBBING) => {
  const canRedo = useSelector(
    (state) => (state.history?.[scope]?.future?.length ?? 0) > 0,
  );
  return canRedo;
};

export default useCanRedo;
